<template>
  <div id="ThreeTopLeftContent">
    <c-block-box title="大内容" class="first-floor-item-1">
      <div class="content-wrap">
        <div class="item-wrap item1-wrap">
          <p class="hd-title">用户热点</p>
          <div class="item1-content">
            <!-- <div class="item" v-for="(item,index) in bigContentLists" :key="index">
              <span class="icon">
                <img v-if="![2,3].includes(index)" src="~@/assets/images/wujie_slices/icon／1.png" alt="" />
                <img v-else src="~@/assets/images/wujie_slices/icon／2.png" alt="" />
              </span>
              <div class="data-wrap">
                <div class="name">{{ item.name }}</div>
                <span class="count BoldAlternate">
                  {{ numberSplitWithComma(item.count) }}
                  <span class="dw">万次</span>
                </span>
              </div>
            </div> -->
            <div class="item" v-for="(item,index) in bigContentLists" :key="index">
              <span class="icon el-icon-date"></span>
              <span class="name">{{ item.name }}</span>
              <span class="count-wrap">
                <span class="count">{{ item.count }}</span>
                <span class="dw">万次</span>
              </span>
            </div>
          </div>
        </div>
        <div class="item-wrap item2-wrap">
          <p class="hd-title">热门影视排行</p>
          <div class="item2-content">
            <!-- <DomeEchartWrap ref="PopularFilmRelevisionRanking" id="PopularFilmRelevisionRanking"></DomeEchartWrap> -->
            <div class="item item-progress-wrap" v-for="item in PopularFilmRelevisionRanking">
              <div class="label-wrap">
                <span class="name">{{ item.name }}</span>
                <span class="kc">{{ numberSplitWithComma(item.count) }}</span>
                <!-- <span class="percent">{{ item.sellRate }}%</span> -->
              </div>
              <CcProgress
                :style-wrap="{
                  height: '0.3rem',
                  width: '100%',
                  'background-color': 'rgba(255,255,255,0.1)'
                }"
                :color="'linear-gradient(90deg, #412DD0 0%, #2BD6F9 100%)'"
                :num="+item.rate"
                :show-progress-count="false"
              ></CcProgress>
            </div>
          </div>
        </div>
        <div class="item-wrap item3-wrap">
          <p class="hd-title">热门搜索排行</p>
          <div class="item3-content">
            <!-- <DomeEchartWrap ref="TopSearchRanking" id="TopSearchRanking"></DomeEchartWrap> -->
            <div class="item item-progress-wrap" v-for="item in TopSearchRanking">
              <div class="label-wrap">
                <span class="name">{{ item.name }}</span>
                <span class="kc">{{ numberSplitWithComma(item.count) }}</span>
                <!-- <span class="percent">{{ item.sellRate }}%</span> -->
              </div>
              <CcProgress
                :style-wrap="{
                  height: '0.3rem',
                  width: '100%',
                  'background-color': 'rgba(255,255,255,0.1)'
                }"
                :color="'linear-gradient(90deg, #412DD0 0%, #2BD6F9 100%)'"
                :num="+item.rate"
                :show-progress-count="false"
              ></CcProgress>
            </div>
          </div>
        </div>
        <div class="item-wrap item4-wrap">
          <p class="hd-title">热门应用排行</p>
          <div class="item4-content">
            <!-- <DomeEchartWrap ref="PopularAppRanking" id="PopularAppRanking"></DomeEchartWrap> -->
            <div class="item item-progress-wrap" v-for="item in PopularAppRanking">
              <div class="label-wrap">
                <span class="name">{{ item.name }}</span>
                <span class="kc">{{ numberSplitWithComma(item.count) }}</span>
                <!-- <span class="percent">{{ item.sellRate }}%</span> -->
              </div>
              <CcProgress
                :style-wrap="{
                  height: '0.3rem',
                  width: '100%',
                  'background-color': 'rgba(255,255,255,0.1)'
                }"
                :color="'linear-gradient(90deg, #412DD0 0%, #2BD6F9 100%)'"
                :num="+item.rate"
                :show-progress-count="false"
              ></CcProgress>
            </div>
          </div>
        </div>
        <div class="item-wrap item5-wrap">
          <p class="hd-title">内容概览</p>
          <div class="item5-content">
            <div class="item" v-for="(item,index) in ContentOverviewLists" :key="index">
              <p class="name">{{ item.name }}</p>
              <span class="count BoldAlternate">{{ numberSplitWithComma(parseInt(item.count)) }}</span>
              <div class="super-name-wrap" v-if="index<2">
                <span class="super-name">{{ item.superName }}</span>
                <span class="super-count">+{{ numberSplitWithComma(parseInt(item.superCount)) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="item-wrap item6-wrap">
          <p class="hd-title">内容播放时长</p>
          <div class="item6-content">
            <DomeEchartWrap ref="ContentPlaybackDuration" id="ContentPlaybackDuration"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-wrap item7-wrap">
          <p class="hd-title">内容转换</p>
          <div class="item7-content">
            <DomeEchartWrap ref="ContentConversion" id="ContentConversion"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </c-block-box>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import { ContentConversionEchartOp, ContentPlaybackDurationEchartOp, PopularFilmRelevisionRankingEchartOp, TopSearchRankingEchartOp, PopularAppRankingEchartOp } from './js/ThreeFloorItem1'
import CcProgress from '@/components/DigitalMarketing/CcProgress'
export default {
  mixins: [common],
  name: '',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      bigContentLists: [
        {
          name: '日均开机用户数', count: 1718, key: 'avgOpenUserCount'
        },
        {
          name: '启播日均次数', count: 14612, key: 'avgBroadcastCount'
        },
        {
          name: '精选页日均曝光', count: 4909, key: 'featuredPageExposureCount'
        },
        {
          name: '详情页日均曝光', count: 3366, key: 'detailPageExposureCount'
        },
        // {
        //   name: '精选页曝光', count: 1718
        // },
        {
          name: '搜索页日均曝光', count: 460, key: 'searchPageExposureCount'
        }
      ],
      ContentOverviewLists: [
        {
          name: '总内容数量(集)',
          count: 71899786,
          superName: '本月新增',
          superCount: 1328293
        },
        {
          name: '总内容时长(H)',
          count: 5549739.81,
          superName: '昨日新增',
          superCount: 38870.32
        },
        {
          name: '影视时长(H)', count: 5453994.2
        },
        {
          name: '亲子时长(H)', count: 95745.6
        },
        {
          name: '短视频时长(H)', count: 115558.8
        },
        // {
        //   name: '少儿时长(H)', count: 775
        // },
        {
          name: '应用数量(个)', count: 423
        }
      ],
      PopularFilmRelevisionRanking: [],
      TopSearchRanking: [],
      PopularAppRanking: []
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$refs['ContentPlaybackDuration'].setEchartOption(ContentPlaybackDurationEchartOp({ v: this }))
    this.$refs['ContentConversion'].setEchartOption(ContentConversionEchartOp({ v: this }))
  },
  watch: {
    data: {
      deep: true,
      handler: function (newValue, oldValue) {
        let { userHotspotVO, hotMovieSortList, hotSearchSortList, hotApplicationSortList } = newValue ?? {}
        this.$nextTick(() => {
          this.userHotspotVO(userHotspotVO)
          this.hotMovieSortList(hotMovieSortList)
          this.hotSearchSortList(hotSearchSortList)
          this.hotApplicationSortList(hotApplicationSortList)
        })
      }
    }
  },
  methods: {
    userHotspotVO (val) {
      if (!val) { return }
      this.bigContentLists.forEach(item => {
        item.count = val[item.key] ?? 0
      })
    },
    hotMovieSortList (val) {
      if (!val) { return }

      // this.$nextTick(() => {
      let data = this.commHotLists({ v: val, n: 'movieName', k: 'pv' })
      this.PopularFilmRelevisionRanking = data
    },
    hotSearchSortList (val) {
      if (!val) { return }
      let data = this.commHotLists({ v: val, n: 'title', k: 'pv' })
      this.TopSearchRanking = data
    },
    hotApplicationSortList (val) {
      if (!val) { return }
      let data = this.commHotLists({ v: val, n: 'startAppName', k: 'pv' })
      this.PopularAppRanking = data
    },
    commHotLists ({ v, n, k }) {
      let max = 0
      let data = []
      v.forEach(item => {
        max = max < item[k] ? item[k] : max
        data.push({
          name: item[n] ?? '',
          count: item[k] ?? ''
        })
      })
      data = data.map(item => {
        item.rate = (item.count / max * 100).toFixed(2)
        return item
      })
      return data
    }
  },
  components: {
    DomeEchartWrap,
    CcProgress
  }
}
</script>

<style scoped lang="stylus">
.content-wrap
  padding: 1.5rem 2rem
  display flex
  flex-wrap: wrap;
  height 39.55rem
  justify-content: space-between
  .item-wrap
    width 13.88rem
    // height: 15.55rem
    display flex
    flex-direction: column
    .hd-title
      font-size: 1.3rem
      color: rgba(255, 255, 255, 0.8)
      margin-bottom: 1.5rem
    .item1-content
      color: rgba(135, 135, 135, 1)
      flex-wrap: wrap
      .icon
       font-size: 0.95rem
       background:linear-gradient(360deg, #37B3F0 0%, #40ECC4 100%);
       margin-right: .35rem
       -webkit-background-clip:text;
       -webkit-text-fill-color:transparent;
      .name
        font-size: 0.9rem
        color: rgba(255, 255, 255, .8)
      .count
        font-size: 1.4rem
        color: #fff
      .dw
        font-size: .7rem
        color: #878787;
        margin-left: .25rem
      .item
        display: flex
        align-items: center
        border-bottom: 0.05rem solid rgba(255, 255, 255, 0.1);
        padding 0.63rem 0
      .count-wrap
        margin-left: auto;
    .item2-content,.item3-content,.item4-content,.item6-content,.item7-content
      flex-grow: 1
    .item5-content
      font-size: .95rem
      color: rgba(255, 255, 255, 0.8)
      display flex
      flex-wrap: wrap
      justify-content: space-between
      // .item:nth-of-type(2n)
      //   margin-left: 1.2rem
      .name
        margin-bottom: .4rem
      .count
        font-size: 1.45rem
        color #fff
      .super-name-wrap
        font-size: .75rem
        margin-top: .3rem
        .super-name
          color rgba(255, 255, 255, 0.6)
        .super-count
          color: rgba(24, 105, 255, 1)
      span
        display inline-block
      .item
        margin-bottom:1rem
        min-width 7rem
        flex-grow: 1 0 50%
      .item:last-child
        margin-bottom 0rem
  .item5-wrap
    width 18rem
  .item6-wrap
    width 15rem
  .item7-wrap
    width 28rem
  .item5-wrap,.item6-wrap,.item7-wrap
    height 18rem
  .item1-wrap,.item2-wrap,.item3-wrap,.item4-wrap
    margin-bottom:1.3rem
  .item1-wrap
    display: flex
    flex-direction: column
    .item1-content
      flex-grow: 1
      display: flex
      flex-direction: column
      justify-content: space-between
</style>
